import React, { useEffect } from "react";
import DropDown from "../DropDown/DropDown";
import "./FCustomizations.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setFColor,
  setFFabric,
  setFSize,
  setFSofaType,
} from "../../Redux/FCustomizations/FCustomizations.actions";
import { fabrics, sofaTypes } from "../../Config/constant";
import colorchart from "../../Assets/colorchart.jpg";
import { toggleColorChart } from "../../Redux/Toggles/Toggles.actions";

const FCustomizations = () => {
  const color = useSelector((state) => state.FCustoms.color);
  const size = useSelector((state) => state.FCustoms.size);
  const fabric = useSelector((state) => state.FCustoms.fabric);
  const sofaType = useSelector((state) => state.FCustoms.sofaType);
  const data = useSelector((state) => state.products.activeProduct);
  const dispatch = useDispatch();

  const handleSizeChange = (value) => {
    const fullSize = data.others.sizes.filter(
      (size) => size.value === value
    )[0];
    dispatch(setFSize(fullSize));
  };

  return (
    <div className="FCustoms">
      <h2>Customizations</h2>
      {!data.others.isSofa ? (
        <>
          <DropDown
            name="size"
            text="Size"
            data={data.others.sizes}
            value={size.value}
            onChange={(e) => handleSizeChange(e.target.value)}
          />
          <DropDown
            name="fabric"
            text="Fabric"
            data={fabrics}
            value={fabric.value}
            onChange={(e) =>
              dispatch(
                setFFabric(
                  fabrics.find((fabric) => fabric.value === e.target.value)
                )
              )
            }
          />
          <img
            onClick={() => dispatch(toggleColorChart(true))}
            src={colorchart}
            alt="color chart"
            className="colorImg"
          />
          <DropDown
            name="color"
            text="Color"
            data={fabric.colors}
            value={color}
            colors
            onChange={(color) => dispatch(setFColor(color.target.value))}
          />
        </>
      ) : (
        <>
          <DropDown
            name="corner"
            text="Sofa Type"
            data={sofaTypes}
            value={sofaType}
            colors
            onChange={(e) => dispatch(setFSofaType(e.target.value))}
          />
        </>
      )}
    </div>
  );
};

export default FCustomizations;
